var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"actTabs"},[_vm._l((_vm.routerLink),function(item){return [(_vm.curActivityId != '0')?_c('router-link',{key:item.path,attrs:{"to":{ path: item.path }}},[_vm._v(_vm._s(item.name))]):_vm._e()]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }